export const idx_data_weight_hole_depth = [];

idx_data_weight_hole_depth.push({
  depth: '',
});

idx_data_weight_hole_depth.push({
  depth: '0.5',
});

idx_data_weight_hole_depth.push({
  depth: '1',
});

idx_data_weight_hole_depth.push({
  depth: '1.5',
});

idx_data_weight_hole_depth.push({
  depth: '2',
});

idx_data_weight_hole_depth.push({
  depth: '2.5',
});

idx_data_weight_hole_depth.push({
  depth: '3',
});

idx_data_weight_hole_depth.push({
  depth: '3.5',
});

idx_data_weight_hole_depth.push({
  depth: '4',
});

idx_data_weight_hole_depth.push({
  depth: '4.5',
});
